// Navbar.jsx
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import Logo from './Logo';
import ChatBell from './ChatBell';

export default function Navbar({ onBack, onOpenPackage }) {
  return (
    <nav style={{backgroundColor: '#111318', borderBottom: '1px solid #1e2028'}}
      className="px-6 py-3 flex items-center justify-between sticky top-0 z-40">
      <div className="flex items-center gap-3">
        {onBack && (
          <button onClick={onBack}
            style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}
            className="w-8 h-8 rounded-xl flex items-center justify-center transition duration-200 hover:border-orange-500">
            <FaArrowLeft style={{fontSize: '12px', color: '#9ca3af'}} />
          </button>
        )}
        <Logo size="sm" />
      </div>
      <div className="flex items-center gap-1">
        <ChatBell onOpenChat={onOpenPackage} />
      </div>
    </nav>
  );
}